const tz = { timeZone: 'Asia/Tokyo' } as const;
export const fmtTime = (iso: string) => new Date(iso).toLocaleTimeString('ja-JP', { ...tz, hour: 'numeric', minute: '2-digit' });
export const fmtDateTime = (iso: string) => new Date(iso).toLocaleString('ja-JP', { ...tz, month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
